import { KeycloakService } from 'keycloak-angular';
import { environment } from "../environments/environment";
import { isPlatformBrowser } from '@angular/common';
import { AppInitService } from './app-init.service';

export const initializeKeycloak = (keycloak: KeycloakService, platformId: Object, appInitService: AppInitService) => async () => {
    console.log('Initializing Keycloak...');
    
    if (isPlatformBrowser(platformId)) {
        await keycloak.init({
            config: {
                url: environment.keycloak.authority,
                realm: environment.keycloak.realm,
                clientId: environment.keycloak.clientId,
            },
            loadUserProfileAtStartUp: true,
            initOptions: {
                onLoad: 'check-sso',
                silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
                checkLoginIframe: false,
                redirectUri: environment.keycloak.redirectUri,
            },
        });

        if (keycloak.isLoggedIn()) {
            const token = keycloak.getKeycloakInstance().token;
            const refreshToken = keycloak.getKeycloakInstance().refreshToken;
            localStorage.setItem('accessToken', token+"");
            localStorage.setItem('refreshToken', refreshToken+"");
        }

        appInitService.init();

    } else {
        console.warn('Keycloak init called on server');
    }
};
